import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
// import Enum from 'cg-enum'
import { Common } from '@/networks/api'
import IndexPage from '@/views/IndexPage/store'
// import CourseDetail from '@/views/CourseDetail/store'
import NewCourseDetail from '@/views/NewCourseDetail/store'
import CourseCenter from '@/views/CourseCenter/store'
import AddPurchase from '@/views/AddPurchase/store'
import Article from '@/views/Article/store'
import SearchPage from '@/views/SearchPage/store'
import types from './types'

Vue.use(Vuex)

export function createStore() {
  return new Vuex.Store({
    modules: {
      IndexPage,
      // CourseDetail,
      NewCourseDetail,
      CourseCenter,
      AddPurchase,
      Article,
      SearchPage
    },
    state: {
      protocol: 'https:',
      regionList: null,
      gradeList: null,
      gradeEnum: null,
      subjectName: null,
      subjectNameZh: null,
      subjectEnum: null,
      xAreaID: null,
      // 登录相关
      userIsLogin: false,
      cookies: null,
      topAdv: null,
      bottomAdv: null,
      currentGrade: null,
      shadeAdv: null,
      showGradingQuestion: false, // 英语定级问题
      showGradingResult: false, // 英语定级结果
      navigation: null, // 导航条信息
      expTag: null,
      traceid: '',
      cartSwitch: null,
      customerInstance: null
    },
    mutations: {
      [types.SET_EXP_TAG](state, payload) {
        state.expTag = payload
      },
      [types.SET_NAVIGATION](state, payload) {
        state.navigation = payload
      },
      [types.SET_SHADE_ADV](state, payload) {
        state.shadeAdv = payload
      },
      [types.SET_CURRENTGRADE](state, payload) {
        state.currentGrade = payload
        Cookies.set('currentGrade', payload, {
          domain: '.xueersi.com'
        })
      },
      [types.SET_PROTOCOL](state, payload) {
        state.protocol = payload
      },
      [types.SET_SUBJECTS](state, payload) {
        payload.push({
          id: 0,
          lid: 0,
          name: '全部',
          val: 0,
          division_id: 0,
          division_name: '',
          order: 0
        })
        const subjectNameZh = {}
        for (let i = 0; i < payload.length; i++) {
          const item = payload[i]
          subjectNameZh[item.id] = item.name
        }
        state.subjectNameZh = subjectNameZh
        state.subjectEnum = subjectNameZh
      },
      [types.SET_REGION](state, payload) {
        state.regionList = payload
      },
      [types.SET_GRADES](state, payload) {
        state.gradeList = payload
        const gradeEnum = {}
        for (let i = 0; i < payload.length; i++) {
          const item = payload[i]
          gradeEnum[item.id] = item
        }
        state.gradeEnum = gradeEnum
      },
      [types.SET_XAREAID](state, payload) {
        console.log('SET_XAREAID==', payload)
        state.xAreaID = payload
      },
      [types.SET_USERISLOGIN](state, payload) {
        state.userIsLogin = payload
      },
      [types.SET_COOKIES](state, payload) {
        state.cookies = payload
      },
      [types.SET_TOP_ADV](state, payload) {
        // console.log(`======SET_TOP_ADV=====${payload}`)
        state.topAdv = payload
      },
      [types.SET_BOTTOM_ADV](state, payload) {
        // console.log(`======SET_BOTTOM_ADV=====${payload}`)
        state.bottomAdv = payload
      },
      [types.SET_SHOWGRAIDNGQUESTION](state, payload) {
        state.showGradingQuestion = payload
      },
      [types.SET_SHOWGRADINGRESULT](state, payload) {
        state.showGradingResult = payload
      },
      [types.SET_TRACEID](state, payload) {
        state.traceid = payload
      },
      [types.SET_CART_SWITCH](state, payload) {
        state.cartSwitch = Number(payload)
      }
    },
    actions: {
      // 获取购物车页面入口开关
      async [types.GET_CART_SWITCH]({ state, commit, rootState }, { route }) {
        try {
          const {
            data: { result }
          } = await Common.getCartSwitch({
            rootState,
            params: {
              switch_grade: route.query.switch_grade || -1,
              switch_subject: route.query.switch_subject || -1
            }
          })
          commit(types.SET_CART_SWITCH, result && result.data && result.data.switch)
        } catch (e) {
          console.log('APIERROR==GET_CART_SWITCH==', e)
        }
      },
      async [types.GET_SUBJECTS]({ state, commit, rootState }) {
        if (state.subjectList) return
        try {
          const { data } = await Common.getSubjects({ rootState })
          commit(types.SET_SUBJECTS, data)
        } catch (e) {
          console.log('APIERROR==GET_SUBJECTS==', e)
        }
      },
      async [types.GET_EXP_TAG]({ state, commit, rootState }) {
        try {
          const ExpTagPost = rootState.userIsLogin
            ? { stuId: rootState.cookies.stu_id, xesId: rootState.cookies.xesId }
            : { xesId: rootState.cookies.xesId }
          const { data } = await Common.getExpTag(ExpTagPost, { rootState }) // 获取exp_tag
          if (Number(data.stat) === 1) {
            commit(types.SET_EXP_TAG, data.data.exp_tag)
          }
        } catch (e) {
          console.log('APIERROR==GET_EXP_TAG==', e)
        }
      },
      async [types.GET_REGION]({ state, commit, rootState }) {
        if (state.regionList) return
        try {
          const { data } = await Common.getRegion({ rootState, params: { device: 1 } })
          commit(types.SET_REGION, data)
        } catch (e) {
          console.log('APIERROR==GET_REGION==', e)
        }
      },
      async [types.GET_GRADES]({ commit, state }) {
        if (state.gradeList) return
        try {
          const { data } = await Common.getGrades({ rootState: state })
          commit(types.SET_GRADES, data)
        } catch (e) {
          console.log('APIERROR==GET_GRADES==', e)
        }
      },
      async [types.GET_SHADE_ADV]({ commit, rootState }, { route }) {
        // 遮罩广告
        if (rootState.cookies.hideShadeAdv) return
        const userId = rootState.cookies.stu_id ? rootState.cookies.stu_id : 0
        const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
        const { grade = userGrade } = route.params
        const info = {
          grade: Number(grade),
          area: Number(rootState.xAreaID)
        }
        try {
          const { data } = await Common.getImags(
            { adslot_id: 4, user_id: Number(userId), info },
            { rootState }
          )
          // console.log('===广告===', data.data.adverts)
          commit(types.SET_SHADE_ADV, data.data)
        } catch (e) {
          console.log('APIERROR=====GET_BANNER_IMAGES====', e)
          commit(types.SET_SHADE_ADV, [])
        }
      },
      async [types.GET_TOP_ADV]({ commit, rootState }, { route }) {
        const userId = rootState.cookies.stu_id ? rootState.cookies.stu_id : 0
        const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
        const { grade = userGrade } = route.params
        const info = {
          grade: Number(grade),
          area: Number(rootState.xAreaID)
        }
        try {
          const { data } = await Common.getImags(
            { adslot_id: 1, user_id: Number(userId), info },
            { rootState }
          )
          commit(types.SET_TOP_ADV, data.data)
        } catch (e) {
          console.log('APIERROR====GET_TOP_ADV error====', e)
          commit(types.SET_TOP_ADV, null)
        }
      },
      async [types.GET_BOTTOM_ADV]({ commit, rootState }, { route }) {
        const userId = rootState.cookies.stu_id ? rootState.cookies.stu_id : 0
        const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
        const { grade = userGrade } = route.params
        const info = {
          grade: Number(grade),
          area: Number(rootState.xAreaID)
        }
        try {
          const { data } = await Common.getImags(
            { adslot_id: 5, user_id: Number(userId), info },
            { rootState }
          )
          commit(types.SET_BOTTOM_ADV, data.data)
        } catch (e) {
          console.log('APIERROR====GET_BOTTOM_ADV error====', e)
          commit(types.SET_TOP_ADV, null)
        }
      },
      async [types.GET_NAVIGATION]({ commit, rootState }) {
        const userInfo = rootState.user ? rootState.user.userInfo : null
        let grade = null
        if (userInfo) {
          grade = userInfo.grade_id || 0
        }
        const province = rootState.xAreaID || 100
        const login = rootState.userIsLogin ? 1 : 0
        const params = {
          login,
          grade: Number(grade),
          province: Number(province)
        }
        try {
          const { data } = await Common.getNavigation(params, { rootState })
          commit(types.SET_NAVIGATION, data)
        } catch (e) {
          // console.log('APIERROR===GET_NAVIGATION error===', e)
          commit(types.SET_NAVIGATION, null)
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js